import React from "react";

import GenericPullAndPushToolView from "../GenericPullAndPushToolView";
import Rapid7InsightCloudConfligListing from "./Rapid7InsightCloudConfigListing";
import Rapid7InsightCloudCredentialsForm from "./Rapid7InsightCloudCredentialsForm";

const Rapid7InsightCloudPullAndPushView = (props: any) => (
  <GenericPullAndPushToolView
    {...props}
    PullCredentialForm={Rapid7InsightCloudCredentialsForm}
    PullConfigListingView={Rapid7InsightCloudConfligListing}
  />
);

export default Rapid7InsightCloudPullAndPushView;
